import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../src/components/Header';
import FeedbackModal from './feedback/_modals/modal';
import AboutUsModal from './about-us/_modals/about-us';
import { LinearProgress } from 'react-md';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Router from '../src/config/router';
import { Urls } from './network/config';
import { Provider } from 'react-redux';
import store from '../src/store';
import { persistor } from '../src/store';
import { PersistGate } from 'redux-persist/integration/react';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quickNavShown: false,
      password: '',
      submitted: false,
      feedBackModalShown: false,
      aboutUsModalShown: false,
      logout: false,
      mainLoading: true,
      navrole: '',
    };

    this.makeSignOutRequest = this.makeSignOutRequest.bind(this);
    this.controller = new AbortController();
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        mainLoading: false,
      });
    }, 1000);
  }

  makeSignOutRequest(event) {
    let self = this;
    event.preventDefault();
    this.setState({ mainLoading: true });
    axios
      .get(Urls.SignOut_URL, {
        method: 'GET',
        withCredentials: true,
        signal: this.controller.signal,
        credentials: 'include',
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('access_token'),
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response)
      .then((response) => {
        self.setState({
          logout: true,
          mainLoading: false,
        });
        if (
          localStorage &&
          localStorage.source &&
          localStorage.source === '1'
        ) {
          window.close();
        } else {
          localStorage.setItem('successMessage', 'Logout Successful');
        }
        window.location.reload();
      })
      .catch(console.log);
  }

  updatequickNav = (value, role) => {
    this.setState({ quickNavShown: value, navrole: role });
  };

  updatefeedBackModalShown = (value) => {
    this.setState({ feedBackModalShown: value });
  };

  updateAboutUsModalShown = (value) => {
    this.setState({ aboutUsModalShown: value });
  };

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let feedBackModalShownClose = () =>
      this.setState({ feedBackModalShown: false });
    let aboutUsModalShownClose = () =>
      this.setState({ aboutUsModalShown: false });
    if (this.state.logout) {
      return <Redirect to="/login" />;
    }

    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <div>
            {this.state.mainLoading && <LinearProgress id="main-loader" />}
            <Header
              quickNavShown={this.state.quickNavShown}
              updatequickNav={this.updatequickNav}
              makeSignOutRequest={this.makeSignOutRequest}
              updatefeedBackModalShown={this.updatefeedBackModalShown}
              updateAboutUsModalShown={this.updateAboutUsModalShown}
            />

            <nav
              className={
                this.state.quickNavShown
                  ? 'side-navigation active'
                  : 'side-navigation'
              }
              style={{
                height: '100%',
                display:
                  this.props.location.pathname === '/login' ||
                  this.props.location.pathname === '/home' ||
                  this.props.location.pathname === '/'
                    ? 'block'
                    : 'block',
              }}
            >
              {this?.state?.navrole === 'Member' ? (
                <ul className="c-footer-list">
                  <li>
                    <Link
                      to={'/home'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/cpdrecord'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      MyCPD Dashboard <i className="fa fa-home"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/mycpd'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Record MyCPD <i className="fa fa-upload"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/cpdclassroom'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      ATI CPD <i className="fa fa-search"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/cpdgo'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      CPDgo <i className="fa fa-registered"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/CPDACCREDITED'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Professional Exams and Further Education{' '}
                      <i className="fa fa-credit-card"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/library'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      CPD Calendar <i className="fa fa-unsorted"></i>
                    </Link>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Close <i className="fa fa-close"></i>
                    </a>
                  </li>
                </ul>
              ) : this?.state?.navrole === 'Staff' ? (
                <ul className="c-footer-list">
                  <li>
                    <Link
                      to={'/cpdadmin'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      CPD Admin Dashboard and Library
                      <i className="fa fa-dashboard"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/memberadmin'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Member Accounts <i className="fa fa-user"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/accredtadmin'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Approved CPD Provider Queue{' '}
                      <i className="fa fa-database"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/monthviewcpd'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Monthly View <i className="fa fa-pencil"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/reportadmin'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Reporting <i className="fa fa-file-excel-o"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/register'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      User Mangement <i className="fa fa-user-plus"></i>
                    </Link>
                  </li>

                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Close <i className="fa fa-close"></i>
                    </a>
                  </li>
                </ul>
              ) : (
                <ul className="c-footer-list">
                  <li>
                    <Link
                      to={'/home'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/cpdrecord'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      MyCPD Dashboard <i className="fa fa-home"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/cpdclassroom'}
                      onClick={() => {
                        this.setState({ quickNavShown: false });
                      }}
                      className="nav-link"
                    >
                      ATI CPD <i className="fa fa-search"></i>
                    </Link>
                  </li>
                </ul>
              )}
            </nav>
            <Router />

            <FeedbackModal
              show={this.state.feedBackModalShown}
              onHide={feedBackModalShownClose}
            />
            <AboutUsModal
              show={this.state.aboutUsModalShown}
              onHide={aboutUsModalShownClose}
            />
            <NotificationContainer />
          </div>
        </PersistGate>
      </Provider>
    );
  }
}
export default App;
